import { Button, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle, Grid, Typography } from "@mui/material";
import { useEffect, useState } from "react";
import { Loader } from "../../../components/CustomLoader";
import { locationServices } from "../../../services/AllServices";
import errorHandler from "../../../utils/errorHandler";
import { capitalize } from "../../../utils/helpers";

const ViewState = ({ id, show, onHide }) => {
  const [data, setData] = useState("");
  const [loading, setLoading] = useState(true);

  const userData = async () => {
    try {
      setLoading(true);
      const response = await locationServices.getByIdState({ stateId: id });
      setData(response.data.data);
    } catch (error) {
      errorHandler(error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    userData();
  }, [id]);

  console.log(data)
  return (
    <Dialog maxWidth="md" fullWidth={true} open={show} onClose={onHide}>
      <DialogTitle as="h2">State Details</DialogTitle>
      {loading ? (
        <Loader />
      ) : (
        <DialogContent dividers>
          <Grid container spacing={2}>
            <Grid item xs={6}>
              <Typography variant="subtitle1">Country Name</Typography>
              <DialogContentText sx={{ marginBlockStart: "1em" }}>
                {capitalize(data?.country?.name)}
              </DialogContentText>
            </Grid>

            <Grid item xs={6} md={6}>
              <Typography variant="subtitle1">Country Code</Typography>
              <DialogContentText sx={{ marginBlockStart: "1em" }}>
                {data?.code}
              </DialogContentText>
            </Grid>

            <Grid item xs={6} md={6}>
              <Typography variant="subtitle1">State</Typography>
              <DialogContentText sx={{ marginBlockStart: "1em" }}>
                {data?.name}
              </DialogContentText>
            </Grid>            

            <Grid item xs={6} md={6}>
              <Typography variant="subtitle1">Status</Typography>
              <DialogContentText sx={{ marginBlockStart: "1em" }}>
                {data?.status ?  "Active" : "Inactive"}
              </DialogContentText>
            </Grid>

          </Grid>
          <DialogActions>
            <Button variant="outlined" onClick={onHide} type="button">
              Close
            </Button>
          </DialogActions>
        </DialogContent>
      )}
    </Dialog>
  );
};

export default ViewState;